import React from "react";

const Search = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  );
};

const Cog = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
      <circle cx="12" cy="12" r="3"></circle>
    </svg>
  );
};

const User = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
      <circle cx="12" cy="7" r="4"></circle>
    </svg>
  );
};
const Calendar = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="16" y1="2" x2="16" y2="6"></line>
      <line x1="8" y1="2" x2="8" y2="6"></line>
      <line x1="3" y1="10" x2="21" y2="10"></line>
      <path d="M8 14h.01"></path>
      <path d="M12 14h.01"></path>
      <path d="M16 14h.01"></path>
      <path d="M8 18h.01"></path>
      <path d="M12 18h.01"></path>
      <path d="M16 18h.01"></path>
    </svg>
  );
};
const RegisterIcon = () => {
  return (
    <svg
      className="navigation-icons"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="15"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <line x1="18" y1="2" x2="22" y2="6"></line>
      <path d="M7.5 20.5 19 9l-4-4L3.5 16.5 2 22z"></path>
    </svg>
  );
};

const Monitor = () => {
  return (
    <svg
      className="text-primary"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
      <line x1="8" y1="21" x2="16" y2="21"></line>
      <line x1="12" y1="17" x2="12" y2="21"></line>
    </svg>
  );
};

const Active = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
    </svg>
  );
};

const Bulb = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="9" y1="18" x2="15" y2="18"></line>
      <line x1="10" y1="22" x2="14" y2="22"></line>
      <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14"></path>
    </svg>
  );
};

const Logout = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
      <polyline points="16 17 21 12 16 7"></polyline>
      <line x1="21" y1="12" x2="9" y2="12"></line>
    </svg>
  );
};

const Mail = () => {
  return (
    <svg
      className="ni ni-email-83"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
      <polyline points="22,6 12,13 2,6"></polyline>
    </svg>
  );
};

const Unlock = () => {
  return (
    <svg
      className="ni ni-lock-circle-open"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
      <path d="M7 11V7a5 5 0 0 1 9.9-1"></path>
    </svg>
  );
};

const Check = () => {
  return (
    <svg
      className="navigation-icons success-icon "
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13.0962 0L6.07044 8.28482L1.91667 4.57232L0 6.28661L6.38789 12L15.3333 1.71429L13.0962 0Z" />
    </svg>
  );
};

const CircleCheck = () => {
  return (
    <svg
      className="navigation-icons"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.9784 6.14424C13.2531 6.4189 13.2531 6.86412 12.9784 7.13864L8.26144 11.8558C7.98679 12.1303 7.5417 12.1303 7.26704 11.8558L5.02158 9.61015C4.74692 9.33563 4.74692 8.89041 5.02158 8.61589C5.2961 8.34123 5.74132 8.34123 6.01584 8.61589L7.76418 10.3642L11.984 6.14424C12.2587 5.86972 12.7039 5.86972 12.9784 6.14424ZM18 9C18 13.9747 13.9741 18 9 18C4.02525 18 0 13.9741 0 9C0 4.02525 4.02594 0 9 0C13.9747 0 18 4.02594 18 9ZM16.5938 9C16.5938 4.80254 13.1969 1.40625 9 1.40625C4.80254 1.40625 1.40625 4.80309 1.40625 9C1.40625 13.1975 4.80309 16.5938 9 16.5938C13.1975 16.5938 16.5938 13.1969 16.5938 9Z" />
    </svg>
  );
};

const Key = () => {
  return (
    <svg
      className="navigation-icons"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.6664 0C7.71819 0 4.5178 3.20039 4.5178 7.14856C4.5178 8.80167 5.07981 10.3231 6.02041 11.5341L5.05394 12.5006L3.58895 11.0356C3.55314 11.0005 3.50503 10.9809 3.45492 10.9809C3.40481 10.9809 3.3567 11.0005 3.32088 11.0356L2.38499 11.9715C2.34994 12.0073 2.33032 12.0554 2.33032 12.1055C2.33032 12.1556 2.34994 12.2037 2.38499 12.2396L3.84997 13.7045L2.79415 14.7604L1.32916 13.2954C1.29335 13.2603 1.24523 13.2407 1.19513 13.2407C1.14502 13.2407 1.0969 13.2603 1.06109 13.2954L0.125194 14.2313C0.0901495 14.2671 0.0705253 14.3152 0.0705253 14.3653C0.0705253 14.4154 0.0901495 14.4635 0.125194 14.4994L1.59018 15.9643L0.0546488 17.4999C0.0196392 17.5352 0 17.583 0 17.6327C0 17.6825 0.0196392 17.7302 0.0546488 17.7656L1.04933 18.7603C1.12223 18.8332 1.24216 18.8332 1.31505 18.7603L7.27846 12.7969C8.5338 13.7705 10.0777 14.2984 11.6664 14.2971C15.6145 14.2971 18.8149 11.0967 18.8149 7.14856C18.8149 3.20039 15.6145 0 11.6664 0ZM15.457 10.9392C14.4458 11.9527 13.0984 12.51 11.6664 12.51C10.2343 12.51 8.88688 11.9527 7.87574 10.9392C6.86224 9.92803 6.30494 8.58062 6.30494 7.14856C6.30494 5.7165 6.86224 4.36909 7.87574 3.35794C8.88688 2.34445 10.2343 1.78714 11.6664 1.78714C13.0984 1.78714 14.4458 2.34445 15.457 3.35794C16.4705 4.36909 17.0278 5.7165 17.0278 7.14856C17.0278 8.58062 16.4705 9.92803 15.457 10.9392Z" />
    </svg>
  );
};

const PersonalInfoIcon = () => {
  return (
    <svg
      className="navigation-icons"
      width="20"
      height="12"
      viewBox="0 0 20 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16672 1.6998C3.72248 1.6998 3.29644 1.87628 2.98231 2.1904C2.66819 2.50452 2.49172 2.93057 2.49172 3.3748C2.49172 3.81904 2.66819 4.24509 2.98231 4.55921C3.29643 4.87333 3.72248 5.0498 4.16672 5.0498C4.61095 5.0498 5.037 4.87333 5.35112 4.55921C5.66524 4.24509 5.84172 3.81904 5.84172 3.3748C5.84172 2.93057 5.66524 2.50452 5.35112 2.1904C5.037 1.87628 4.61095 1.6998 4.16672 1.6998ZM2.09073 5.64327C2.05732 5.6127 2.02452 5.58132 1.99236 5.54916C1.41569 4.97248 1.09172 4.19035 1.09172 3.3748C1.09172 2.55926 1.41569 1.77713 1.99236 1.20045C2.56904 0.623777 3.35117 0.299805 4.16672 0.299805C4.98226 0.299805 5.76439 0.623777 6.34107 1.20045C6.91774 1.77713 7.24172 2.55926 7.24172 3.3748C7.24172 4.19035 6.91774 4.97248 6.34107 5.54916C6.30752 5.58271 6.27327 5.61541 6.23836 5.64724C7.31959 6.32566 8.03338 7.52125 8.03338 8.91647V10.4998V11.1998H7.33338H1.00005H0.300049V10.4998V8.91647C0.300049 7.52051 1.0094 6.32171 2.09073 5.64327ZM4.1596 6.44989C2.77118 6.46079 1.70005 7.53302 1.70005 8.91647V9.7998H6.63338V8.91647C6.63338 7.53717 5.55152 6.46081 4.1596 6.44989ZM19.2084 2.49147H9.70838V1.09147H19.2084V2.49147ZM15.25 6.4498H9.70838V5.0498H15.25V6.4498ZM17.625 10.4081H9.70838V9.00814H17.625V10.4081Z"
      />
    </svg>
  );
};

const Location = () => {
  return (
    <svg
      className="navigation-icons"
      width="15"
      height="20"
      viewBox="0 0 15 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.54981 0.28125C9.40633 0.28125 11.1868 1.01875 12.4996 2.3315C13.8123 3.64426 14.3001 5.14349 14.3001 7C13.8001 12 7.59999 19.25 7.59999 19.25C7.59999 19.25 1.30005 12.5 0.800049 7C0.800049 5.14348 1.28731 3.64426 2.60007 2.3315C3.91282 1.01875 5.6933 0.28125 7.54981 0.28125ZM7.59999 2C6.2739 2 5.00213 2.52678 4.06445 3.46447C3.12677 4.40215 2.59999 5.67392 2.59999 7C2.59999 8 2.59999 10 7.59999 16.71C12.6 10 12.6 8 12.6 7C12.6 5.67392 12.0732 4.40215 11.1355 3.46447C10.1978 2.52678 8.92607 2 7.59999 2Z" />
      <circle cx="7.80005" cy="7.5" r="2.25" strokeWidth="1.5" />
    </svg>
  );
};

const Users = () => {
  return (
    <svg
      className="navigation-icons"
      width="21"
      height="16"
      viewBox="0 0 21 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.8013 1.37791C4.22572 1.37791 3.67371 1.60655 3.26672 2.01355C2.85972 2.42055 2.63107 2.97255 2.63107 3.54813C2.63107 4.12371 2.85972 4.67571 3.26672 5.08271C3.67371 5.4897 4.22572 5.71835 4.8013 5.71835C5.37687 5.71835 5.92888 5.4897 6.33587 5.08271C6.74287 4.67571 6.97152 4.12371 6.97152 3.54813C6.97152 2.97255 6.74287 2.42055 6.33587 2.01355C5.92888 1.60655 5.37687 1.37791 4.8013 1.37791ZM2.56404 6.30203C2.46976 6.22543 2.37906 6.14371 2.29239 6.05703C1.62699 5.39163 1.25317 4.48915 1.25317 3.54813C1.25317 2.60711 1.62699 1.70463 2.29239 1.03922C2.95779 0.37382 3.86027 0 4.8013 0C5.74232 0 6.6448 0.37382 7.3102 1.03922C7.92928 1.6583 8.29596 2.48259 8.34402 3.35221C8.92275 2.96619 9.60699 2.75581 10.3129 2.75581C10.9145 2.75581 11.5004 2.90861 12.0186 3.19271C12.1002 2.38222 12.4589 1.62032 13.04 1.03922C13.7054 0.37382 14.6079 0 15.5489 0C16.4899 0 17.3924 0.37382 18.0578 1.03922C18.7232 1.70463 19.0971 2.60711 19.0971 3.54813C19.0971 4.48915 18.7232 5.39163 18.0578 6.05703C17.9712 6.14371 17.8805 6.22543 17.7862 6.30203C19.1458 7.06837 20.0501 8.51794 20.0501 10.2195V12.1256V12.8089L19.3669 12.8146L14.8125 12.8525C14.8136 12.8933 14.8141 12.9342 14.8141 12.9753V14.8815V15.5704H14.1252H6.50069H5.81174V14.8815V12.9753C5.81174 12.935 5.81225 12.8948 5.81326 12.8548L0.983331 12.8146L0.30011 12.8089V12.1256V10.2195C0.30011 8.51794 1.20445 7.06837 2.56404 6.30203ZM6.05891 11.4789C6.35492 10.6184 6.90139 9.88413 7.61424 9.35688C7.52262 8.70029 7.25524 8.19454 6.87949 7.83438C6.4114 7.38571 5.71094 7.10191 4.7945 7.09634C3.03813 7.10859 1.67802 8.46765 1.67802 10.2195V11.4424L6.05891 11.4789ZM14.5643 11.4766L18.6722 11.4424V10.2195C18.6722 8.4597 17.2997 7.09626 15.5318 7.09626V7.09621C14.9362 7.09334 14.3565 6.94076 13.8432 6.65937C13.7616 7.46985 13.4029 8.23175 12.8218 8.81285C12.7335 8.90122 12.6409 8.98445 12.5446 9.06234C13.4815 9.59085 14.205 10.4419 14.5643 11.4766ZM15.5489 1.37791C16.1245 1.37791 16.6765 1.60655 17.0835 2.01355C17.4905 2.42055 17.7191 2.97255 17.7191 3.54813C17.7191 4.12371 17.4905 4.67571 17.0835 5.08271C16.6765 5.4897 16.1245 5.71835 15.5489 5.71835C14.9733 5.71835 14.4213 5.4897 14.0143 5.08271C13.6074 4.67571 13.3787 4.12371 13.3787 3.54813C13.3787 2.97255 13.6074 2.42055 14.0143 2.01355C14.4213 1.60655 14.9733 1.37791 15.5489 1.37791ZM8.77835 4.76936C9.18534 4.36237 9.73734 4.13372 10.3129 4.13372C10.8885 4.13372 11.4405 4.36237 11.8475 4.76936C12.2545 5.17636 12.4831 5.72836 12.4831 6.30394C12.4831 6.87952 12.2545 7.43152 11.8475 7.83852C11.4405 8.24551 10.8885 8.47416 10.3129 8.47416C9.73734 8.47416 9.18534 8.24551 8.77835 7.83852C8.37135 7.43152 8.1427 6.87952 8.1427 6.30394C8.1427 5.72836 8.37135 5.17636 8.77835 4.76936ZM7.18964 12.9753C7.18964 11.2241 8.54884 9.86532 10.3043 9.85216C12.0632 9.86534 13.4362 11.2281 13.4362 12.9753V14.1925H7.18964V12.9753Z"
      />
    </svg>
  );
};

const Bank = () => {
  return (
    <svg
      className="navigation-icons"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.71631 8.33335H4.04964V14.1667H5.71631V8.33335ZM10.7163 8.33335H9.04964V14.1667H10.7163V8.33335ZM17.7996 15.8334H1.96631V17.5H17.7996V15.8334ZM15.7163 8.33335H14.0496V14.1667H15.7163V8.33335ZM9.88298 2.71668L14.2246 5.00002H5.54131L9.88298 2.71668ZM9.88298 0.833351L1.96631 5.00002V6.66668H17.7996V5.00002L9.88298 0.833351Z" />
    </svg>
  );
};

const Briefcase = () => {
  return (
    <svg
      className="navigation-icons"
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.52948 0H11.0709C11.8463 0 12.4775 0.630992 12.4775 1.40662V2.35107H16.0944C16.7704 2.35107 17.3001 2.88076 17.3001 3.55675V13.9055C17.3001 14.5814 16.7704 15.1111 16.0944 15.1111H1.50578C0.829799 15.1111 0.30011 14.5814 0.30011 13.9055V3.55675C0.30011 2.88076 0.829799 2.35107 1.50578 2.35107H5.12286V1.40662C5.12286 0.630959 5.75382 0 6.52948 0ZM6.32854 2.35107H11.2718V1.40662C11.2718 1.29771 11.1797 1.20567 11.0708 1.20567H6.52948C6.42057 1.20567 6.32854 1.29771 6.32854 1.40662V2.35107ZM16.0944 13.9054H1.50578L1.50033 7.79649H16.0944V13.9054ZM1.49655 3.55754L1.49926 6.59082H16.0944V3.55675H1.50578C1.49937 3.55675 1.49655 3.55754 1.49655 3.55754Z"
      />
    </svg>
  );
};

const Document = () => {
  return (
    <svg
      className="navigation-icons"
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.7456 4.85906L11.0582 0.17168C10.9488 0.0622266 10.7995 0 10.6439 0H2.44073C1.47148 0 0.682922 0.788555 0.682922 1.75781V18.2422C0.682922 19.2114 1.47148 20 2.44073 20H14.1595C15.1287 20 15.9173 19.2114 15.9173 18.2422V5.27344C15.9173 5.11367 15.8502 4.96363 15.7456 4.85906ZM11.2298 2.00051L13.9168 4.6875H11.8157C11.4926 4.6875 11.2298 4.42465 11.2298 4.10156V2.00051ZM14.1595 18.8281H2.44073C2.11765 18.8281 1.8548 18.5653 1.8548 18.2422V1.75781C1.8548 1.43473 2.11765 1.17188 2.44073 1.17188H10.0579V4.10156C10.0579 5.07082 10.8465 5.85938 11.8157 5.85938H14.7454V18.2422C14.7454 18.5653 14.4826 18.8281 14.1595 18.8281Z" />
      <path d="M11.8157 8.28125H4.78448C4.46089 8.28125 4.19855 8.54359 4.19855 8.86719C4.19855 9.19078 4.46089 9.45312 4.78448 9.45312H11.8157C12.1393 9.45312 12.4017 9.19078 12.4017 8.86719C12.4017 8.54359 12.1393 8.28125 11.8157 8.28125Z" />
      <path d="M11.8157 10.625H4.78448C4.46089 10.625 4.19855 10.8873 4.19855 11.2109C4.19855 11.5345 4.46089 11.7969 4.78448 11.7969H11.8157C12.1393 11.7969 12.4017 11.5345 12.4017 11.2109C12.4017 10.8873 12.1393 10.625 11.8157 10.625Z" />
      <path d="M11.8157 12.9688H4.78448C4.46089 12.9688 4.19855 13.2311 4.19855 13.5547C4.19855 13.8783 4.46089 14.1406 4.78448 14.1406H11.8157C12.1393 14.1406 12.4017 13.8783 12.4017 13.5547C12.4017 13.2311 12.1393 12.9688 11.8157 12.9688Z" />
      <path d="M9.47198 15.3125H4.78448C4.46089 15.3125 4.19855 15.5748 4.19855 15.8984C4.19855 16.222 4.46089 16.4844 4.78448 16.4844H9.47198C9.79558 16.4844 10.0579 16.222 10.0579 15.8984C10.0579 15.5748 9.79558 15.3125 9.47198 15.3125Z" />
    </svg>
  );
};

const Refresh = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.64 2.35C12.19 0.9 10.2 0 7.99 0C3.57 0 0 3.58 0 8C0 12.42 3.57 16 7.99 16C11.72 16 14.83 13.45 15.72 10H13.64C12.82 12.33 10.6 14 7.99 14C4.68 14 1.99 11.31 1.99 8C1.99 4.69 4.68 2 7.99 2C9.65 2 11.13 2.69 12.21 3.78L8.99 7H15.99V0L13.64 2.35Z"
        fill="#2624A7"
      />
    </svg>
  );
};

const Eye = ({ props }) => {
  return (
    <svg
      className={props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path d="M15 12c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3zm9-.449s-4.252 8.449-11.985 8.449c-7.18 0-12.015-8.449-12.015-8.449s4.446-7.551 12.015-7.551c7.694 0 11.985 7.551 11.985 7.551zm-7 .449c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5z" />
    </svg>
  );
};

const BarGraph = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 2v20h20"></path>
      <path d="M17 18V9"></path>
      <path d="M12 18V4"></path>
      <path d="M7 18v-4"></path>
    </svg>
  );
};

const ArrowGraph = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
      <polyline points="16 7 22 7 22 13"></polyline>
    </svg>
  );
};

const PiChart = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
      <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
    </svg>
  );
};

const ArrowUp = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="12" y1="19" x2="12" y2="5"></line>
      <polyline points="5 12 12 5 19 12"></polyline>
    </svg>
  );
};

const ArrowDown = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="12" y1="5" x2="12" y2="19"></line>
      <polyline points="19 12 12 19 5 12"></polyline>
    </svg>
  );
};

const Percentage = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="19" y1="5" x2="5" y2="19"></line>
      <circle cx="6.5" cy="6.5" r="2.5"></circle>
      <circle cx="17.5" cy="17.5" r="2.5"></circle>
    </svg>
  );
};

const Edit = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
    </svg>
  );
};

const Trash = () => {
  return (
    <svg
      className="text-danger"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="3 6 5 6 21 6"></polyline>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
      <line x1="10" y1="11" x2="10" y2="17"></line>
      <line x1="14" y1="11" x2="14" y2="17"></line>
    </svg>
  );
};

const Prev = ({ props }) => {
  return (
    <svg
      className={props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="15 18 9 12 15 6"></polyline>
    </svg>
  );
};

const Next = ({ props }) => {
  return (
    <svg
      className={props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="9 18 15 12 9 6"></polyline>
    </svg>
  );
};

const More = ({ props }) => {
  return (
    <svg
      className={props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="1"></circle>
      <circle cx="12" cy="5" r="1"></circle>
      <circle cx="12" cy="19" r="1"></circle>
    </svg>
  );
};

const Bell = ({ props }) => {
  return (
    <svg
      className={props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
      <path d="M2 8c0-2.2.7-4.3 2-6"></path>
      <path d="M22 8a10 10 0 0 0-2-6"></path>
    </svg>
  );
};

const Wallet = ({ props }) => {
  return (
    <svg
      className={props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4"></path>
      <path d="M4 6v12c0 1.1.9 2 2 2h14v-4"></path>
      <path d="M18 12a2 2 0 0 0-2 2c0 1.1.9 2 2 2h4v-4h-4z"></path>
    </svg>
  );
};

const Verify = ({ props }) => {
  return (
    <svg
      className={props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 3c-1.2 0-2.4.6-3 1.7A3.6 3.6 0 0 0 4.6 9c-1 .6-1.7 1.8-1.7 3s.7 2.4 1.7 3c-.3 1.2 0 2.5 1 3.4.8.8 2.1 1.2 3.3 1 .6 1 1.8 1.6 3 1.6s2.4-.6 3-1.7c1.2.3 2.5 0 3.4-1 .8-.8 1.2-2 1-3.3 1-.6 1.6-1.8 1.6-3s-.6-2.4-1.7-3c.3-1.2 0-2.5-1-3.4a3.7 3.7 0 0 0-3.3-1c-.6-1-1.8-1.6-3-1.6Z"></path>
      <path d="m9 12 2 2 4-4"></path>
    </svg>
  );
};

const AlertCircle = ({ props }) => {
  return (
    <svg
      className={props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
  );
};

const AlertTriangle = ({ props }) => {
  return (
    <svg
      className={props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
      <line x1="12" y1="9" x2="12" y2="13"></line>
      <line x1="12" y1="17" x2="12.01" y2="17"></line>
    </svg>
  );
};

const Info = ({ props }) => {
  return (
    <svg
      className={props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="16" x2="12" y2="12"></line>
      <line x1="12" y1="8" x2="12.01" y2="8"></line>
    </svg>
  );
};

export {
  Search,
  User,
  Cog,
  Monitor,
  Active,
  Bulb,
  Logout,
  Mail,
  Unlock,
  Check,
  CircleCheck,
  Key,
  PersonalInfoIcon,
  Location,
  Users,
  Bank,
  Briefcase,
  Document,
  Refresh,
  Eye,
  BarGraph,
  ArrowGraph,
  PiChart,
  ArrowUp,
  ArrowDown,
  Percentage,
  Edit,
  Trash,
  Prev,
  Next,
  More,
  Bell,
  Wallet,
  Verify,
  RegisterIcon,
  Calendar,
  AlertCircle,
  AlertTriangle,
  Info,
};
